import styles from "./styles.module.css";
type ViewCardProps = {
  title: string;
  value: string;
  size?: string;
  category?: string;
};
const ViewCard = ({
  title,
  value,
  size = "medium",
  category,
}: ViewCardProps) => {
  return (
    <div className={`${styles.cardContainer} ${styles[size]}`}>
      <div className={styles.titleContainer}>
        <h6>
          <b>{category}</b>
        </h6>
        {title}
      </div>
      <div className={styles.inputContainer}>{value}</div>
    </div>
  );
};

export default ViewCard;
